import Service, { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { queryManager } from 'ember-apollo-client';

export default class PurchaseReceiptVoucherService extends Service {
  @service receiptSettings;
  @service voucherReceipt;

  @queryManager apollo;

  @task
  *getVouchersToPrintTask(serials) {
    let shouldPrint = yield this.shouldPrintTask.perform();

    if (shouldPrint) {
      return yield this.voucherReceipt.getVouchersBySerialsTask.perform(
        serials
      );
    }
    return [];
  }

  @task
  *printInElectronTask(voucherIds) {
    let shouldPrint = yield this.shouldPrintTask.perform();

    if (shouldPrint) {
      yield this.voucherReceipt.printInElectronTask.perform(voucherIds);
    }
  }

  @task
  *shouldPrintTask() {
    let receiptSettings = yield this.receiptSettings.fetchReceiptSettings();
    if (receiptSettings?.printVoucher) {
      return true;
    }
    return false;
  }
}
